import { IconName, IconPrefix, library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

library.add(fas, fab);

type PropType = {
  lib?: IconPrefix;
  name?: IconName;
  color?: string;
  spin?: boolean;
  pulse?: boolean;
  fixedWidth?: boolean;
  inverse?: boolean;
  listItem?: boolean;
  flip?: 'horizontal' | 'vertical' | 'both';
  size?: '1x' | 'xs' | 'lg' | 'sm' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x';
  rotation?: 90 | 180 | 270;
  pull?: 'left' | 'right';
};

const IconComponent = ({
  lib = 'fas',
  name = 'question',
  color,
  spin,
  pulse,
  fixedWidth,
  inverse,
  listItem,
  flip,
  size = '1x',
  rotation,
  pull,
}: PropType) => (
  <FontAwesomeIcon
    icon={[lib || '', name || '']}
    color={color}
    spin={spin}
    pulse={pulse}
    fixedWidth={fixedWidth}
    inverse={inverse}
    listItem={listItem}
    flip={flip}
    size={size}
    rotation={rotation}
    pull={pull}
    className={`icon icon-${name}`}
  />
);

export default IconComponent;
